<template>
  <section class="admin-content " id="contact-search">
    <Navbar/>
      <main class="admin-main">
       <div class="bg-dark m-b-30">
           <div class="container">
               <div class="row p-b-60 p-t-60">

                   <div class="col-md-6 text-center mx-auto text-white p-b-30">

                       <h3 class="h3">SMS Notifications</h3>

                       <download-excel :data="recipients" :fields="json_fields" class="btn btn-success"
                              :escapeCsv=false name="recipients.xls">
                            <span class="fe fe-download"></span>
                      Export Contact Data
                      </download-excel>

                   </div>

               </div>
           </div>
       </div>
       <section class="">
           <div class="container">

               <div class="row list">
                   <div class="col-lg-8 offset-md-2">
                       <div class="card m-b-30">

                           <div class="card-body">
                                  <div class="form-row">

                                    <div class="form-group col-md-12">
                                        <label for="inputPassword4">Select Recipient Category </label>
                                        <select class="form-control"  v-model="sms_type">
                                          <option  value="single">Single</option>
                                          <option  value="bulk">Bulk</option>

                                     </select>
                                    </div>
                                    <div class="form-group col-md-12" v-if="sms_type == 'bulk'">
                                        <label for="inputPassword4">Select Recipient Category </label>
                                        <select class="form-control"  v-model="category" @change="getRecipients">
                                          <option  value="State Civil Servant Healthcare Plan">State Civil Servant Healthcare Plan</option>
                                          <option  value="LGA Civil Servant Healthcare Plan">LGA Civil Servant Healthcare Plan </option>
                                          <option  value="State Pensioneers Healthcare Plan">State Pensioneers Healthcare Plan</option>
                                          <option  value="LGA Pensioneers Healthcare Plan">LGA Pensioneers Healthcare Plan</option>
                                          <option  value="Oganized Private Sector Plan">Organized Private Sector Plan</option>
                                          <option  value="Universal Basic Education Healthcare Plan">Universal Basic Education  Healthcare Plan</option>
                                          <option value="Tertiary Institution Contributory Health Insurance Plan (TICHIP)">Tertiary Institution Contributory Health Insurance Plan (TICHIP)</option>
                                          <option  value="Basic Healthcare Provision Fund">Basic Healthcare Provision Fund</option>
                                          <option  value="Vulnerable Groups">Vulnerable Groups</option>
                                          <option  value="Voluntary Contributor">Voluntary Contributor</option>
                                          <option  value="Organized Community Healthcare Plan">Organized Community Healthcare Plan</option>
                                     </select>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="inputCity"><i class="fe fe-calendar"></i> Start Date </label>
                                        <input type="date" class="form-control" v-model="from"  @change="pushDate"/>
                                    </div>

                                     <div class="form-group col-md-6">
                                        <label for="inputCity"><i class="fe fe-calendar"></i> End Date </label>
                                        <input type="date" class="form-control" v-model="to"   @change="pushDate"/>
                                    </div>

                                    <div class="form-group col-md-12" v-if="sms_type == 'bulk'">
                                       <label for="inputAddress">Bulk  Recipients: <span class="text-primary">{{recipients.length}} recipeints</span></label>
                                       <textarea name="name" rows="8" class="form-control" placeholder="Phone Numbers"  :value="recipients"></textarea>
                                   </div>
                                   <div class="form-group col-md-12" v-if="sms_type == 'single'">
                                      <label for="inputAddress">Manual Input Recipient: </label>
                                      <textarea name="name" rows="3" class="form-control" placeholder="Phone Number"  v-model="singlerecipient"></textarea>
                                  </div>
                                   <div class="form-group col-md-12">
                                      <label for="inputAddress">Message</label>
                                      <textarea name="name" rows="8" class="form-control" placeholder="Message Body here" v-model="message"></textarea>
                                      <p>
                                          <span class="text-primary">{{message.length}} characters/160 per page</span>
                                      </p>
                                  </div>

                                   </div>


                                       <div class="form-group">
                                           <button class="btn btn-primary btn-block btn-lg" @click="sendSMS">Send Message</button>
                                       </div>

                           </div>
                       </div>
                   </div>

               </div>
           </div>

           <div class="vld-parent">
                <loading :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"></loading>
            </div>


       </section>
      </main>
   </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
     Navbar, Loading
  },
  data(){
    return{
      editor: ClassicEditor,
      user:null,
      category:"",
      sms_type:"",
      message:"",
      recipients:"",
      singlerecipient:"",
      postId:"",
      edit:false,
      isLoading: false,
      fullPage: true,
      date:"",
      from:"",
      to:"",
      json_fields: {
                'PhoneNumber':'phone_number',
                'FIRST NAME':'firstname',
                'MESSAGES': {
                field:'userprovider.agency_name',
              callback: (value) => {
              return `  ${value}`;
          }
        },

                 },
                json_data: [],
                json_meta: [
                [
                    {
                    key: "charset",
                    value: "utf-8",
                    },
                ]],


    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))

  },

  methods:{
    pushDate(){
      this.date = 'date'
    },
    clearIt(){
      this.recipients =""
      this.messages =""
      this.category =""

    },

getRecipients(){
  this.isLoading = true
  this.axios.get(`/api/v1/auth/sms/filter/${this.category}/4`,{
    params:{
      date: this.date,
      from: this.from,
      to: this.to
    }
  })
              .then(response => {
                  this.recipients = response.data
                  console.log(response)
                  this.isLoading = false
                  this.$toasted.info('Recipients Synced Successfully', {position: 'top-center', duration:3000 })

              })
              .catch(error => {
                  console.error(error);
                  this.isLoading = false
                  this.$toasted.error('Error Syncing', {position: 'top-center', duration:3000 })


              })
},




sendSMS(){

        if (this.sms_type == 'bulk') {
          this.isLoading = true;
          this.axios.post(`https://api.bulksmslive.com/v2/app/sms?email=faisalnas7@gmail.com&password=skrull123&sender_name=ZAMCHEMA&message=${this.message}&recipients=${this.recipients}`, {

          })
          .then(response=>{
              console.log(response);
              let reply = response.data.msg
              this.clearIt();
              this.isLoading = false;
              this.$toasted.info(`${reply}`, {position: 'top-center', duration:3000 })

          })
          .catch(error=>{
              console.log(error.response)
          })
        }
        else {
          this.isLoading = true;
          this.axios.post(`https://api.bulksmslive.com/v2/app/sms?email=faisalnas7@gmail.com&password=skrull123&sender_name=ZAMCHEMA&message=${this.message}&recipients=${this.singlerecipient}`, {

          })
          .then(response=>{
              console.log(response);
              let reply = response.data.msg
              this.clearIt();
              this.isLoading = false;
              this.$toasted.info(`${reply}`, {position: 'top-center', duration:3000 })

          })
          .catch(error=>{
              console.log(error.response)
          })
        }


    }

  },
  created(){
    this.getProviders()
  }

}
</script>
